import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { ChangeVehicleLink } from 'site-modules/shared/components/appraisal/trade-in-appraiser-links/trade-in-appraiser-links';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { APPRAISER_HIGHLIGHTS_CONTENT_FILE_PATH } from 'site-modules/shared/constants/appraiser-highlights';
import { fillContentStringWithMMY } from 'site-modules/appraiser/pages/appraiser/appraiser-highlights-utils';

export const HighlightsMMYTitleUI = ({ vehicle = {}, year, highlightsContent = DEFAULT_CONTENT }) => {
  const make = get(vehicle, 'makeName', '');
  const model = get(vehicle, 'modelName', '');

  const { header, subHeader } = highlightsContent.child('highlights').child('highlights-1').getAllMetadata();

  return (
    <div className="highlights-mmy-title mt-1_5 mb-1_5">
      <h1 className="heading-3 text-white text-shadow-contrast">
        <span className="fw-bold">{fillContentStringWithMMY(header, { make, model, year })}</span>
      </h1>
      <p className="size-16 text-white mt-0_5 mb-0">{fillContentStringWithMMY(subHeader, { make, model, year })}</p>
      <ChangeVehicleLink className="mt-0_5 text-shadow-contrast" color="white" />
    </div>
  );
};

HighlightsMMYTitleUI.propTypes = {
  vehicle: VehicleEntities.StyleWithoutSubmodels,
  year: PropTypes.number.isRequired,
  highlightsContent: CmsEntities.Content,
};

export const stateToPropsConfig = {
  highlightsContent: bindToContent(() => APPRAISER_HIGHLIGHTS_CONTENT_FILE_PATH),
};

export const HighlightsMMYTitle = connectToModel(HighlightsMMYTitleUI, stateToPropsConfig);
